// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles__modal___1IPsR","modal__content":"styles__modal__content___28-qu","modal__overlay":"styles__modal__overlay___1y9GK"};